"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xPlatform = exports.GC_RECIPE_LINKS = exports.GC_UNCATEGORIZED = exports.SEND_UPLOAD_URL = void 0;
exports.SEND_UPLOAD_URL = "new-picture";
exports.GC_UNCATEGORIZED = "Uncategorized";
exports.GC_RECIPE_LINKS = "Linked Recipes";
exports.xPlatform = {
    "main-web": "main-web",
    ios: "ios",
    android: "android",
};
//# sourceMappingURL=enumStrings.js.map